import { render, staticRenderFns } from "./ManAllowanceUpload.vue?vue&type=template&id=23d3d42a&"
import script from "./ManAllowanceUpload.vue?vue&type=script&lang=js&"
export * from "./ManAllowanceUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports